export default __webpack_public_path__ + "static/media/icon-clock.8f58b960.svg";